
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 82.85 73.08"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.43 54.03c-12.48 0-24.29-6.1-32.76-16.87 8.47-10.76 20.28-16.87 32.76-16.87s24.28 6.11 32.75 16.87C65.71 47.93 53.9 54.03 41.43 54.03zm40-18.89c-9.88-13.89-24.46-21.85-40-21.85s-30.11 8-40 21.85l-1.45 2 1.45 2c9.88 13.93 24.47 21.89 40 21.89s30.1-8 40-21.84l1.44-2zm-40 10a8 8 0 118-8 8 8 0 01-8 7.98zm0-22.91a15 15 0 1015 14.95 15 15 0 00-15-14.97z"}}),_c('path',{attrs:{"fill":"#fff","d":"M64.304 10.736l7.304 7.304-48.854 48.854-7.304-7.304z"}}),_c('path',{attrs:{"fill":"#231f20","d":"M67.041.005l7.305 7.304L8.563 73.091 1.26 65.787z"}})])
          )
        }
      }
    